"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var useMoneyFormatter_1 = require("../../../../../hooks/useMoneyFormatter");
var WinnerAnnouncement = function (_a) {
    var winner = _a.winner;
    var moneyFormat = (0, useMoneyFormatter_1.useMoneyFormatter)().moneyFormat;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "winner-announcement" }, { children: [(0, jsx_runtime_1.jsxs)("span", { children: [winner.username, " a castigat"] }), (0, jsx_runtime_1.jsx)("span", { children: moneyFormat(winner.winAmountCurrency, winner.currency) })] })));
};
exports.default = WinnerAnnouncement;
